import React from 'react';
import { Container, Title, Text } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';
import Rating from '../../atoms/Rating';
import Media, { MediaProps } from '../../molecules/Media';

export interface BlockTrustSectionProps {
    title: string;
    text?: string;
    rating?: number;
    ratingLink?: any;
    badges?: string[];
    media?: MediaProps['media'];
}

export default function BlockTrustSection({
    title,
    text,
    rating,
    ratingLink,
    badges,
    media,
}: BlockTrustSectionProps) {
    return (
        <section className="pt-xxxl pb-mega" data-theme="dark">
            <Container className="relative">
                <div className="row">
                    {!!media && (
                        <div className="relative h-[388px] lg:h-auto col-span-full lg:col-span-3 xl:col-span-5 hd:col-span-4 rounded-medium !w-full">
                            <Media
                                className="rounded-medium"
                                media={media}
                                layout="fill"
                            />
                        </div>
                    )}
                    <div className="pt-40 md:pt-48 lg:pt-0 lg:pr-48 col-span-full lg:col-span-4 lg:col-start-5 xl:col-span-6 xl:col-start-7 flex flex-col justify-center">
                        {!!badges && badges?.length > 0 && (
                            <div className="flex gap-4 mb-sm">
                                {badges.map((badge, index) => (
                                    <img
                                        key={index}
                                        className="h-40 xl:h-56 w-auto max-w-fit"
                                        alt="Badges"
                                        src={badge}
                                    />
                                ))}
                            </div>
                        )}
                        {!!title && (
                            <Title
                                isHtml
                                component="h4"
                                className={cls(
                                    'font-regular text-text-primary text-h300',
                                )}>
                                {title}
                            </Title>
                        )}
                        {!!text && (
                            <Text
                                isHtml
                                component="div"
                                className="text-b300 pt-lg md:pr-64 lg:pr-0 xl:pr-96">
                                {text}
                            </Text>
                        )}
                        {!!rating && (
                            <Rating
                                value={rating}
                                link={ratingLink}
                                className="pt-xl"
                            />
                        )}
                    </div>
                </div>
            </Container>
        </section>
    );
}
